import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeaderPanel from './../../HeaderPanel';
import FooterPanel from './../../FooterPanel';
import MembershipHeroPanel from "./MembershipHeroPanel";
import MembershipBuyThanksPanel from "./MembershipBuyThanksPanel";
import MerchPanel from "./../../MerchPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class MembershipThanksPage extends React.Component {
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    let self = this;
  }

  componentWillUnmount() {
  }

  render() {
    const { classes } = this.props;

    let self = this;

      return (
          <div className={classes.branding}>
              <HeaderPanel showLogo={true} ref={this.myRef} page={'classes'} />
              <MembershipHeroPanel />
              <MembershipBuyThanksPanel />
              <MerchPanel />
              <FooterPanel />
          </div>
      );
  }
}

export default withStyles(useStyles)(MembershipThanksPage)
